import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import { arrayOfObjectsToObject } from '@finect/front-utils/arrayOfObjectsToObject';
export var getLastValues = function getLastValues(fields) {
  var lastValues = fields.map(function (field) {
    var lastValue = field.lastValue;
    if (!lastValue) {
      return null;
    }
    var _ref = lastValue || {},
      _ref$date = _ref.date,
      date = _ref$date === void 0 ? null : _ref$date,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? null : _ref$value;
    return {
      field: field.field,
      date: date,
      value: value
    };
  }).filter(function (item) {
    return item;
  });
  return arrayOfObjectsToObject(lastValues, 'field', 'value');
};